module.exports = __webpack_public_path__ + "../resources/img/ic_fold_left.1fe002d2.svg";